import { Box } from '@mui/material'
import React from 'react'
import { useInView } from 'react-intersection-observer'

import ListItem, { EntityListItemProps } from './ListItem'

const InView: React.FC<EntityListItemProps> = (props) => {
  const { address } = props

  const [ref, inView] = useInView({
    threshold: 0,
    triggerOnce: true,
  })

  return (
    <div ref={ref} style={{ flexGrow: 1 }}>
      {inView ? <ListItem address={address} /> : <Box flexGrow={1} height={50} />}
    </div>
  )
}

export default InView
